import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice de Trigonométrie";
const DESCRIPTION =
  "Calculatrice de Trigonométrie pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de trigonométrie, calculatrice de trigonométrie, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/trigonometry";
function TrigonometryCalculator() {
  const [angle, setAngle] = useState("");
  const [result, setResult] = useState({});
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const deg = parseFloat(angle);
      if (isNaN(deg)) {
        setError("Veuillez entrer un angle valide");
        setResult({});
        return;
      }
      const rad = (deg * Math.PI) / 180;
      setResult({
        sin: Math.sin(rad).toFixed(4),
        cos: Math.cos(rad).toFixed(4),
        tan: Math.tan(rad).toFixed(4)
      });
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <p>
                  La <strong>trigonométrie</strong> est la branche des mathématiques
                  qui étudie les relations entre les angles et les longueurs dans les triangles.
                  Les fonctions <strong>sin</strong>, <strong>cos</strong> et <strong>tan</strong>
                  sont fondamentales en physique, ingénierie, architecture et navigation.
                  Entrez un angle en degrés pour calculer instantanément ses valeurs trigonométriques.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Angle (degrés):</label>
                    <input
                      type="number"
                      value={angle}
                      onChange={(e) => setAngle(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {Object.keys(result).length > 0 && (
                  <div>
                    <p className="p-3 mb-2 bg-success text-white">
                      sin({angle}°) = {result.sin}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      cos({angle}°) = {result.cos}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      tan({angle}°) = {result.tan}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Fonctions trigonométriques</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Les fonctions trigonométriques définissent des rapports entre les côtés d'un triangle rectangle :
                      </p>
                      <ul>
                        <li><strong>sin(θ)</strong> = côté opposé / hypoténuse</li>
                        <li><strong>cos(θ)</strong> = côté adjacent / hypoténuse</li>
                        <li><strong>tan(θ)</strong> = côté opposé / côté adjacent</li>
                      </ul>
                      <p>
                        Elles sont largement utilisées en physique, ingénierie, navigation, architecture
                        et traitement du signal.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Degrés et radians</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Les angles peuvent s'exprimer en degrés ou en radians. Un cercle complet
                        vaut 360° ou 2π radians. Formules de conversion :
                      </p>
                      <ul>
                        <li>Degrés en radians : rad = degrés × π / 180</li>
                        <li>Radians en degrés : degrés = rad × 180 / π</li>
                      </ul>
                      <p>
                        Exemple : 90° = π/2 rad ≈ 1,5708 rad.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Fonctions trigonométriques inverses</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Les fonctions inverses permettent de retrouver un angle à partir d'un rapport :
                      </p>
                      <ul>
                        <li><strong>arcsin(0,5)</strong> = 30°</li>
                        <li><strong>arccos(0,5)</strong> = 60°</li>
                        <li><strong>arctan(1)</strong> = 45°</li>
                      </ul>
                      <p>
                        Elles sont utiles pour déterminer l'angle d'inclinaison d'une pente
                        ou l'angle de tir en balistique.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Valeurs remarquables</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Quelques valeurs clés à connaître :
                      </p>
                      <ul>
                        <li>sin(0°) = 0 ; cos(0°) = 1 ; tan(0°) = 0</li>
                        <li>sin(30°) = 0,5 ; cos(30°) ≈ 0,866 ; tan(30°) ≈ 0,577</li>
                        <li>sin(45°) ≈ 0,707 ; cos(45°) ≈ 0,707 ; tan(45°) = 1</li>
                        <li>sin(60°) ≈ 0,866 ; cos(60°) = 0,5 ; tan(60°) ≈ 1,732</li>
                        <li>sin(90°) = 1 ; cos(90°) = 0 ; tan(90°) = indéfini</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default TrigonometryCalculator;
